import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ChatService } from 'src/app/services/chat.service';
import { TicketsRetidosService } from 'src/app/services/tickets-retidos.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-ticket-retido-bloquear-email',
  templateUrl: './modal-ticket-retido-bloquear-email.component.html',
  styleUrls: ['./modal-ticket-retido-bloquear-email.component.scss']
})
export class ModalTicketRetidoBloquearEmailComponent implements OnInit, OnDestroy {
  @Input() bloquear_email;
  @Input() is_bloquear_email;
  @Input() is_from_chat: boolean = false;
  @Input() chat_id: string = '';

  bloqueio = false;
  remetente = '__all__';
  descricao_texto = '';
  contato = ''
  dominio = ''
  bloquear_liberar = '';
  titulo_modal = ''
  aviso_modal = ''
  selector: string;
  disableClienteSelect: boolean = true
  cliente = '__all__';
  newSubs: Subscription;
  salvandoBloqueio = false;
  private readonly spinnerName = 'spinnerBloquearRemetenteEmail';

  constructor(
    private serviceTicketsRetidos: TicketsRetidosService,
    private toastr: ToastrService,
    public translate: TranslateService,
    public activeModal: NgbActiveModal,
    private elemRef: ElementRef,
    private chatService: ChatService,
    private spinner: NgxSpinnerService
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    this.getDominio(this.bloquear_email.bloquear_email.email_cliente);
    this.titulo_modal = this.is_bloquear_email ? this.translate.instant('LIBERAR_EMAIL') : this.translate.instant('BLOQUEAR_REMETENTE');
    this.aviso_modal = this.is_bloquear_email ? this.translate.instant('ALERTA_TICKET_EMAIL') : this.translate.instant('ALERTA_TICKET_RETIDO');
    if (this.is_from_chat) {
      if (this.bloquear_email.bloquear_email.cliente) {
        this.disableClienteSelect = true;
        this.remetente = this.bloquear_email.bloquear_email.cliente;
        this.cliente = '';
      }
    } else if (this.is_bloquear_email) this.disableClienteSelect = false, this.remetente = ""
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
    this.spinner.hide(this.spinnerName);
  }

  getDominio(email) {
    if (email) {
      this.dominio = email.split('@')[1]
    }
  }

  validBloqueio() {
    return this.remetente == '' || this.remetente == undefined
  }

  close(result?) {
    this.activeModal.close(result);
  }

  bloquearLiberar() {
    Swal.fire(
      {
        title: this.is_bloquear_email ? this.translate.instant('DESEJA_LIBERAR_EMAIL') : this.translate.instant("DESEJA_BLOQUEAR_REMETENTE"),
        icon: this.is_bloquear_email ? "success" : "error",
        focusConfirm: true,
        showCancelButton: true,
        confirmButtonText: this.translate.instant("SIM"),
        cancelButtonText: this.translate.instant("NAO"),
      }
    ).then(
      (result) => {
        if (result.isConfirmed) {
          this.bloqueio = true;
        }
      }
    )
  }

  bloquearLiberarRementente() {
    if (this.salvandoBloqueio) {
      return;
    }
    if (this.is_from_chat) {
      let payload;
      if (this.cliente) {
        payload = {
          modo: 'global',
          email: this.bloquear_email.bloquear_email.email_cliente
        };
      } else {
        payload = {
          modo: 'cliente',
          cliente_id: this.remetente['id'] ? this.remetente['id'] : this.remetente
        };
      }

      this.salvandoBloqueio = true;
      this.spinner.show(this.spinnerName);
      this.newSubs = this.chatService.bloquearRemetenteChatEmail(payload, this.chat_id)
        .pipe(finalize(() => {
          this.salvandoBloqueio = false;
          this.spinner.hide(this.spinnerName);
        }))
        .subscribe({
          next: () => {
            this.toastr.show(this.translate.instant('BLOQUEADO_SUCESSO'), '', environment.toastrConfig('success'));
            this.close(true);
          },
          error: (error) => console.error(error)
        });
    } else {
      var payload = {
        chamadoRetencao: {
          id: this.bloquear_email.bloquear_email.id,
          cliente_id: this.remetente['id'] ? this.remetente['id'] : this.remetente,
          descricao: this.descricao_texto
        }
      }

      this.salvandoBloqueio = true;
      this.spinner.show(this.spinnerName);

      if (this.is_bloquear_email === true) {
        payload.chamadoRetencao['is_dominio'] = false;

        this.newSubs = this.serviceTicketsRetidos.liberarRemetente(payload)
          .pipe(finalize(() => {
            this.salvandoBloqueio = false;
            this.spinner.hide(this.spinnerName);
          }))
          .subscribe(
            () => {
              this.toastr.show(this.translate.instant('SALVO_SUCESSO'), '', environment.toastrConfig('success'));
              this.close(true);
            },
            (error) => console.error('bloquearLiberarRemetente', error)
          );
      } else {
        this.newSubs = this.serviceTicketsRetidos.bloquearRemetente(payload)
          .pipe(finalize(() => {
            this.salvandoBloqueio = false;
            this.spinner.hide(this.spinnerName);
          }))
          .subscribe(
            () => {
              this.toastr.show(this.translate.instant('SALVO_SUCESSO'), '', environment.toastrConfig('success'));
              this.close(true);
            },
            (error) => console.error('bloquearLiberarRemetente', error)
          );
      }
    }
  }

  disableCliente(disable) {
    if (disable) {
      this.remetente = '__all__'
    } else {
      this.remetente = ''
    }
    this.disableClienteSelect = disable
  }
}